// Copyright (c) 2017 Deere & Company

import Product, {getDefaultState as getProductDefaultState} from '@deere/cps-it.warranty-model-factory/lib/product';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const resetProduct = state =>
    Product.update(state, {
        $set: getProductDefaultState()
    });

const updateProduct = (state, action) =>
    Product.update(state, {
        $set: action.data
    });

export default (state = getDefaultState().product, action) => {

    const actionTypes = {
        [actions.RESET_STATUS_CHANGE_REQUEST_STATE]: resetProduct,
        [actions.UPDATE_STATUS_CHANGE_REQUEST_PRODUCT_DETAILS]: updateProduct
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/status-change-request/reducers/product.js